import { XIcon } from "@heroicons/react/outline";
import useStore from "../hooks/useStore";

const WebinarTopBar = () => {
  const closeWebinarDialog = useStore((state) => state.closeWebinarDialog);

  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <div className="tw-flex tw-items-center tw-space-x-2">
        <img
          src="/Mktg/images/tsg/svg/webinars.svg"
          alt="webinars calendar"
          className="tw-w-8 tw-h-8"
        />
        <span className="tw-text-tr-date/75 tw-text-lg">Webinar</span>
      </div>

      <XIcon
        className="tw-w-6 tw-h-6 tw-text-tr-date/75 tw-cursor-pointer"
        onClick={closeWebinarDialog}
      />
    </div>
  );
};

export default WebinarTopBar;
